import { render, staticRenderFns } from "./BCorp.vue?vue&type=template&id=0757baaf&"
import script from "./BCorp.vue?vue&type=script&lang=js&"
export * from "./BCorp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports